import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';
import TermsAndConditionDrawer from '../terms/TermsAndConditionDrawer';
import CreateTermsDrawer from '../terms/CreateTermsDrawer';

const TermsAndConditions = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);

  const fetchTerms = async () => {
    try {
      const res = await api.get('/api/terminos');
      setTerms(res.data);
    } catch (err) {
      console.error('Error al cargar términos:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  const STATUS_COLORS = {
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-gray-100 text-gray-800',
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-1">Gestión de Términos y Condiciones</h1>
        <p className="text-gray-600 text-sm">Administra los títulos y contenidos visibles en la sección de términos del sitio web.</p>
      </div>

      <div className="flex justify-end mb-4">
        <button onClick={() => setShowCreateDrawer(true)} className="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-700 transition">
          + Agregar Término
        </button>
      </div>

      {loading ? (
        <p className="text-gray-500">Cargando...</p>
      ) : terms.length === 0 ? (
        <div className="bg-white shadow rounded-lg p-8 text-center border border-dashed border-gray-300">
          <h2 className="text-xl font-semibold text-gray-700">No hay términos registrados</h2>
          <p className="text-gray-500 mb-4">Agrega el primer término y condición.</p>
          <button onClick={() => setShowCreateDrawer(true)} className="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-700 transition">
            + Agregar Término
          </button>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded-lg">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="py-2 px-4 border-b text-left">Título</th>
                <th className="py-2 px-4 border-b text-left">Estado</th>
                <th className="py-2 px-4 border-b text-left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {terms.map((term) => (
                <tr key={term.id} className="border-b hover:bg-gray-50">
                  <td className="py-2 px-4">{term.section_title}</td>
                  <td className="py-2 px-4">
                    <span className={`inline-block text-xs px-2 py-1 rounded ${STATUS_COLORS[term.status] || 'bg-gray-100 text-gray-800'}`}>
                      {term.status === 'active' ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td className="py-2 px-4">
                    <button
                      onClick={() => setSelectedTerm(term)}
                      className="text-blue-800 hover:underline text-sm"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <TermsAndConditionDrawer
        isOpen={!!selectedTerm}
        onClose={() => setSelectedTerm(null)}
        term={selectedTerm}
        onSaved={() => {
          fetchTerms();
          setSelectedTerm(null);
        }}
      />

      <CreateTermsDrawer
        isOpen={showCreateDrawer}
        onClose={() => setShowCreateDrawer(false)}
        onCreated={() => {
          fetchTerms();
          setShowCreateDrawer(false);
        }}
      />
    </div>
  );
};

export default TermsAndConditions;
